import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';
import { Skeleton } from '@hivebrite/design-system/Skeleton';

import { Col, Row } from 'hb-react/shared/components/DesignSystem/Grid';

const PublicationNewsLoader = () => (
  <StyledRow>
    <Col>
      <Box flexDirection="column" p={6}>
        <Skeleton height="100px" isLarge mb={4} width="205px" />
        <Skeleton height={38} isLarge mb={2} width="50%" />
        <Skeleton height={14} mb={4} width="20%" />
        <Skeleton height={2} isLarge mb={4} width="100%" />
        <Skeleton height={16} isLarge mb={2} width="100%" />
        <Skeleton height={16} isLarge mb={2} width="100%" />
        <Skeleton height={16} isLarge mb={2} width="100%" />
        <Skeleton height={16} isLarge width="90%" />
      </Box>
    </Col>
  </StyledRow>
);

export default PublicationNewsLoader;

const StyledRow = styled(Row)`
  width: 100%;
`;
